const cardNames = {
  visa: 'Visa',
  master: 'MC',
  american_express: 'Amex',
  discover: 'Disc.',
  'diners-club': 'DC',
  dankrot: 'Dankrot',
  jcb: 'JCB',
};

export const SPREEDLY_CC_TYPES = {
  visa: 'visa',
  master: 'master',
  american_express: 'amex',
  discover: 'discover',
  'diners-club': 'diners-club',
};

export default type => cardNames[String(type).toLowerCase()] || 'unknown card type';

export const SPREEDLY_PLATFORM_TYPE = 'spreedly';
export const YOURPAY_PLATFORM_TYPE = 'yourpay';



// WEBPACK FOOTER //
// ./src/lib/card-type-names.js